import styled, { css } from 'styled-components'

export const GrowOnHoverSVG = styled.svg(
  ({ transformDuration = 100, transformScale = 1.05, showShadow = false }) =>
    css`
      cursor: pointer;
      transform: scale(1);
      transition: transform ${transformDuration}ms ease-in-out;

      filter: ${showShadow
        ? 'drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.12))'
        : 'none'};

      &:hover {
        transform: scale(${transformScale});
      }
    `
)
